"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DEF_CONFIG = void 0;

var _react = require("react");

var _UiUtils = require("./UiUtils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var DEF_CONFIG = {
  timeoutLoad: 10,
  timeoutEndload: 700
};
exports.DEF_CONFIG = DEF_CONFIG;

function _callDispatch(callback, dispatch, getState) {
  // callback(dispatch, getState)
  dispatch(function (dispatch, getState) {
    return callback(dispatch, getState);
  });
}
/**
 * @class DiffLoaderUI
 * @classdesc Gestione in differita load/unload.
 */


var DiffLoaderUI = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param {*} config 
   */
  function DiffLoaderUI(config) {
    _classCallCheck(this, DiffLoaderUI);

    this.requests = {};
    /** @type {Object} */

    this.config = _objectSpread(_objectSpread({}, DEF_CONFIG), config);
  }
  /**
   * @memberof DiffLoaderUI#
   * @param {*} urlId 
   * @param {*} options 
   */


  _createClass(DiffLoaderUI, [{
    key: "_getId",
    value: function _getId(urlId, options) {
      if (options) {
        if (options.loadNoDelay) return null;

        if (options.loadHandler && options.endloadHandler) {
          return null;
        }

        if (options.loadId) {
          return _UiUtils.default.clean(options.loadId);
        }
      }

      if (urlId) return _UiUtils.default.clean(urlId);
      return "__AGUI_LOADER_GENERAL__";
    }
    /**
     * @memberof DiffLoaderUI#
     * @param {*} urlId 
     * @param {*} callbackLoad 
     * @param {*} dispatch 
     * @param {*} options 
     */

  }, {
    key: "load",
    value: function load(urlId, callbackLoad, dispatch, options) {
      var self = this;
      if (!callbackLoad || !dispatch) return;
      var timeoutLoad = options && options.timeoutLoad || this.config.timeoutLoad;

      var id = this._getId(urlId, options);

      if (!id) {
        // || timeoutLoad < 1) {
        // callbackLoad(dispatch);
        _callDispatch(callbackLoad, dispatch);

        return;
      }

      var req = this.requests[id]; //console.debug("diffLoaderUI.load", id);

      if (!req) {
        req = {
          id: id,
          callbackLoad: callbackLoad,
          dispatch: dispatch,
          inload: false,
          mustLoad: true,
          timeoutLoadRef: null,
          numRequests: 0
        };
        this.requests[id] = req;

        if (!req.timeoutLoadRef) {
          req.timeoutLoadRef = setTimeout(function () {
            //console.debug("diffLoaderUI SHOW load", id);
            req.numRequests++;

            if (!req.inLoad) {
              req.timeoutLoadRef = null;

              if (req.mustLoad) {
                req.mustLoad = false;
                req.inload = true;

                _callDispatch(req.callbackLoad, req.dispatch);
              } else {
                self._cleanupRequest(req.id);
              }
            }
          }, timeoutLoad);
        }
      } else {
        req.numRequests++; //console.debug("diffLoaderUI load numreq++", id);
      }
    }
    /**
     * @memberof DiffLoaderUI#
     * @param {*} urlId 
     * @param {*} callbackEndload 
     * @param {*} dispatch 
     * @param {*} options 
     */

  }, {
    key: "endload",
    value: function endload(urlId, callbackEndload, dispatch, options) {
      var self = this;
      if (!callbackEndload || !dispatch) return null;
      var timeoutEndload = options && options.timeoutEndload || this.config.timeoutEndload;

      var id = this._getId(urlId, options);

      if (!id) {
        // || timeoutEndload < 1) {
        // dispatch((dispatch) => callbackEndload(dispatch));
        _callDispatch(callbackEndload, dispatch);

        return;
      }

      var req = this.requests[id]; //console.debug("diffLoaderUI endload", id);

      if (!req) {
        // req = {
        //     id: id,
        //     callbackEndload: callbackEndload,
        //     inload: false,
        //     dispatch: dispatch,
        //     timeoutEndloadRef: null,
        //     numRequests: 0
        // };
        // this.requests[id] = req;
        console.debug("endload chiamato prima del load", id);
        return;
      }

      if (!req.callbackEndload) {
        req.callbackEndload = callbackEndload;
      }

      if (req.numRequests <= 1) {
        // if (req.timeoutEndloadRef) {
        //    clearTimeout(req.timeoutEndloadRef); 
        //    req.timeoutEndloadRef = null;
        // }
        req.mustLoad = false;

        if (!req.timeoutEndloadRef) {
          req.timeoutEndloadRef = setTimeout(function () {
            console.debug("diffLoaderUI HIDE load", id);
            req.numRequests = 0;
            req.timeoutEndloadRef = null;

            if (req.inload) {
              // req.callbackEndload(req.dispatch);
              _callDispatch(req.callbackEndload, req.dispatch);

              req.inload = false;

              self._cleanupRequest(req.id);
            }
          }, timeoutEndload);
        }
      } else {
        req.numRequests--; // console.debug("diffLoaderUI endload numReq--", id);
      }
    }
    /**
     * @memberof DiffLoaderUI#
     * @param {*} id 
     */

  }, {
    key: "_cleanupRequest",
    value: function _cleanupRequest(id) {
      if (!this.requests[id]) return; // console.debug("diffLoaderUI cleanup", id);

      delete this.requests[id];
    }
  }]);

  return DiffLoaderUI;
}();

exports.default = DiffLoaderUI;